<template>
    <div class="page-content">

        <div id="careers" class="section bg-svg-smallgiant">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">

                        <h1 class="title color-white mb-10">Careers</h1>

                        <p v-if="careers.length == 0" class="lead mb-5">There are currently no posted openings, but we're keeping <router-link class="underline" to="/contact">a door open</router-link> for exceptional engineers.</p>

                        <div v-if="careers.length > 0" class="col-sm-12 ml-auto mr-auto">
                            <div class="row">
                                <career v-for="(item, index) in careers"
                                    class="mb-3 col-sm-12 col-md-6 col-lg-4 mx-auto"
                                    v-bind:item="item"
                                    v-bind:key="index"
                                    v-bind:index="index"
                                    ref="career"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <div id="why" class="section bg-svg-moneytree">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title mb-10 color-white">Why work at Sleep Jar?</h1>

                        <div class="mt-5 container">
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-comment-dollar mr-2"></i>Competitive salary</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-home mr-2"></i>Work from home</span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-clinic-medical mr-2"></i>Medical, dental, vision insurance</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-life-ring mr-2"></i>Life insurance</span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-chart-pie mr-2"></i>401k retirement plan</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-plane-departure mr-2"></i>Unlimited PTO</span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-baby-carriage mr-2"></i>Paid parental leave</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-heart mr-2"></i>Paid bereavement</span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-gifts mr-2"></i>17 paid company holidays</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-suitcase-rolling mr-2"></i>Conference travel support</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div id="mission" class="section bg-svg-lighthousesea">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">

                        <h1 class="title color-white">Sleep Jar exists to improve the mental health of people around the world</h1>
                    </div>
                </div>
            </div>
        </div>


        <div id="origins" class="section bg-svg-silverbirch">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">

                        <h1 class="title color-white mb-5">Company Origin</h1>

                        <p class="lead text-left">Nick Schwab published the first sleep sound app (rain sounds) on Amazon Alexa in 2016 to block out noise from his upstairs apartment neighbor. The app quickly became one of the most-used and highly rated, so Nick began to publish additional sounds. As usage of the apps continued to grow and began to generate revenue, Nick founded Invoked Apps LLC as a home for his creations in June 2017. After a few years, Nick decided to rebrand the company as <span class="bold underline">Sleep Jar</span>, leave his comfortable career at Ford Motor Company to focus on the business full time, and started to build a team. Today, Sleep Jar serves millions of customers every month and is supported by a diverse team of <span class="bold underline">Dreamers</span> who are passionate about improving mental health.</p>

                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
export default {
    data () {
        return {
            "careers": [
                {
                    "title": "Senior Android Developer",
                    "fa_background": "fab fa-android",
                    "type": "Full-Time Salaried",
                    "location": "Michigan, USA",
                    "salary": "$120-150k",
                    "link": "mailto:careers@sleepjar.com?subject=Android Developer Application&body=[INTRODUCE YOURSELF, ATTACH YOUR RESUME, AND PROVIDE LINKS TO YOUR APPS ON THE PLAY STORE]" //"https://www.linkedin.com/jobs/view/3177223342/"
                },/*
                {
                    "title": "Full Stack Web Developer",
                    "fa_background": "fab fa-node-js",
                    "type": "Full-Time Salaried",
                    "location": "Michigan, USA",
                    "salary": "$100-130k",
                    "link": "mailto:careers@sleepjar.com?subject=Full Stack Web Developer Application&body=[INTRODUCE YOURSELF, ATTACH YOUR RESUME, AND PROVIDE LINKS TO YOUR WEB PROJECTS]"
                }
                */
            ]
        };
    },
    name: 'careers',
    metaInfo: {
        title: 'Careers',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'View open roles at Sleep Jar and apply to join our team!'
            }
        ]
    },
    methods: {
    },
    computed: {
    },
    components: {
    },
    mounted(){
    }
}
</script>
